@import 'styles/mixins';
@import 'styles/variables';

.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.formTitle {
  @include xl-semibold;
  color: var(--neutral-90);
  margin-bottom: 24px;
}
.formBody {
  height: auto;

  [data-autopilot-system-redesign='on'] & {
    margin-top: 20px;
  }

  @include for-phone-only {
    width: 100%;
    padding-bottom: 88px; /* space for fixed footer so content is not covered */

    input {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
.footer {
  margin: 0 -20px;

  @include for-phone-only {
    margin: 0;
    margin-top: auto;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.cancelButton {
  margin-left: 16px;
}

.identityTitle {
  @include lg-semibold;
  color: var(--neutral-90);
  margin-bottom: 24px;
}
